import styled from '../../../utils/styled';

export default styled('span')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.base,
  color: 'rgba(0,0,0,.65)',
  lineHeight: 1.5,
  marginLeft: 7
}));



// WEBPACK FOOTER //
// ./src/components/Checkbox/private/CheckboxLabel.tsx